import classNames from '@jd/jmtd-tools/es/classnames';
import PropTypes from 'prop-types';
import React from 'react';
export default function DropdownButtonPanel(_ref) {
  var className = _ref.className,
      left = _ref.left,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, 'jmtd-dropdown-button-panel')
  }, /*#__PURE__*/React.createElement("div", {
    className: "jmtd-dropdown-button-panel-left"
  }, left), /*#__PURE__*/React.createElement("div", {
    className: "jmtd-dropdown-button-panel-right"
  }, children));
}
DropdownButtonPanel.propTypes = {
  children: PropTypes.node,
  left: PropTypes.node,
  className: PropTypes.string
};
DropdownButtonPanel.defaultProps = {
  children: null,
  left: null,
  className: ''
};